import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';
import './PresentModeSwitch.scss';

const PresentModeSwitch = props => {
  const { label, checked, onChange } = props;

  return (
    <FormControlLabel
      className="present-mode-switch"
      control={<Switch color="primary" checked={checked} onChange={onChange} />}
      label={label}
      labelPlacement="start"
      style={{ margin: 0 }}
    />
  );
};

export default PresentModeSwitch;
